import React from "react";
import {
  closestCorners,
  DndContext,
  PointerSensor,
  KeyboardSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";

import Container from "./Container";
import "./index.scss";
import { Segment } from "semantic-ui-react";

function PipelineReports({ stages, onDragEnd, isLoading }) {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor)
  );

  const findContainer = (id) => {
    if (stages.find(stage => stage.id === id)) {
      return id;
    }
    return stages.find(stage => stage.items.some(item => item.id === id))?.id;
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (!over) {
      return;
    }

    const sourceContainer = findContainer(active.id);
    const targetContainer = findContainer(over.id);

    if (!sourceContainer || !targetContainer) {
      return;
    }

    if (sourceContainer === targetContainer) {
      return;
    }
    const movingItem = stages.find(stage => stage.id === sourceContainer)?.items?.find(item => item.id === active.id);

    if (onDragEnd) {
      onDragEnd({
        itemId: active.id,
        fromStageId: sourceContainer,
        toStageId: targetContainer,
        item: movingItem
      });
    }
  };

  return (
    <Segment basic loading={isLoading}>
      <div className="Pipeline_Reports">
        <div className="Pipeline_Reports__ContainerWrapeer">
          <DndContext
            sensors={sensors}
            collisionDetection={closestCorners}
            onDragEnd={handleDragEnd}
          >
            {stages?.map(({ name: stageName, id: stageId, items }, index) => (
              <Container
                key={stageId}
                id={stageId}
                title={stageName}
                items={items}
                isFirstStage={index === 0}
                isLastStage={index === stages.length - 1}
              />
            ))}
          </DndContext>
        </div>
      </div>
    </Segment>
  );
}

export default PipelineReports;
